import styled from "styled-components";

export const UserCardWrapper = styled.div`
  width: 92%;
  height: 189px;
  position: relative;
  top: -50px;
  perspective: 1000px; /* 3D 효과를 위한 perspective 속성 추가 */
`;

export const CardContainer = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  transition: transform 1.3s;
  transform-style: preserve-3d;
`;

export const CardFlipContainer = styled(CardContainer)<{ isFlipped: boolean }>`
  transform: ${(props) => (props.isFlipped ? "rotateY(180deg)" : "rotateY(0)")};
`;

export const CardFace = `
  width: 100%;
  height: 100%;
  border-radius: 9.14px;
  background-image: url("/image-web/home/wallet-back.svg");
  background-size: cover;
  padding: 20px 16px 15px;
  position: absolute;
  backface-visibility: hidden; /* 뒷면 숨김 처리 */
  -webkit-backface-visibility: hidden; /* Safari 지원 */
`;

export const MainInfoWrapper = styled.div`
  ${CardFace}
  background-image: url("/image-web/home/info-back.svg");
  transform: rotateY(180deg);
  > .title-button {
    position: absolute;
    top: 20px;
    right: 16px;

    display: flex;
    flex-direction: column;
    gap: 5px;

    > .qr-icon-wrapper {
      width: 47px;
      height: 47px;
      border-radius: 7px;
      border: 0.914px solid #8d6de8;
      background: #fff;

      display: flex;
      align-items: center;
      justify-content: center;
    }

    > .title {
      background: #21252880;
      font-family: esamanru;
      font-weight: 700;
      font-size: 9px;
      line-height: 100%;
      letter-spacing: 0.73px;
      text-align: center;
      color: #ffffff;
      width: 50px;
      height: 20px;
      border-radius: 7.31px;
      line-height: 20px;
      position: relative;
      cursor: pointer;
      pointer-events: auto;
    }

    > .title::before {
      content: "";
      position: absolute;
      inset: 0;
      border-radius: 7.31px;
      padding: 1px;
      background: linear-gradient(
        90deg,
        #8d6de8 0%,
        #ffffff 50.5%,
        #3a87d5 100%
      );
      -webkit-mask: linear-gradient(#fff 0 0) content-box,
        linear-gradient(#fff 0 0);
      -webkit-mask-composite: xor;
      mask-composite: exclude;
    }
  }

  > .header {
    display: flex;
    flex-direction: column;
    gap: 8px;

    > .name {
      font-weight: 600;
      font-size: 13px;
      color: #ffffffbf;
    }

    > .item {
      display: flex;
      align-items: center;
      gap: 5px;

      > .seed {
        color: #fff;
        font-family: esamanru;
        font-size: 24px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
      }

      > .point {
        align-items: center;
        display: flex;
        gap: 10px;

        font-weight: 400;
        font-size: 13px;
        color: #ffffff99;

        span {
          font-weight: 400;
          font-size: 13px;
          color: #ffffffcc;
        }

        > img {
          width: 14px;
          height: 14px;
        }
      }
    }
  }
`;

export const MainInfoUserWrapper = styled.div`
  display: flex;
  margin-top: 43px;
  gap: 30px;

  > .item {
    display: flex;
    flex-direction: column;
    gap: 3px;

    > .title {
      font-weight: 600;
      font-size: 13px;
      color: #ffffffbf;
    }

    > .value {
      font-family: esamanru;
      font-weight: 500;
      font-size: 19px;
      color: #ffffff;
    }
  }
`;

export const MainWalletWrapper = styled.div`
  ${CardFace}
  background-image: url("/image-web/home/wallet-back.svg");
  transform: rotateY(0deg);
`;

export const MainWalletTitleButtonWrapper = styled.div`
  position: absolute;
  top: 20px;
  right: 16px;
  display: flex;
  flex-direction: column;
  gap: 5px;

  > .title {
    background: #21252880;
    font-family: esamanru;
    font-weight: 700;
    font-size: 9px;
    line-height: 100%;
    letter-spacing: 0.73px;
    text-align: center;
    color: #ffffff;
    width: 50px;
    height: 20px;
    border-radius: 7.31px;
    line-height: 20px;
    position: relative;
    cursor: pointer;
    pointer-events: auto;
  }

  > .title::before {
    content: "";
    position: absolute;
    inset: 0;
    border-radius: 7.31px;
    padding: 1px;
    background: linear-gradient(90deg, #8d6de8 0%, #ffffff 50.5%, #3a87d5 100%);
    -webkit-mask: linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;
  }

  > .qr-icon-wrapper {
    width: 47px;
    height: 47px;
    border-radius: 7px;
    border: 0.914px solid #8d6de8;
    background: #fff;

    display: flex;
    align-items: center;
    justify-content: center;
    > .qr-icon {
      width: 100%;
      height: 100%;
    }
  }
`;

export const WalletHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 11px;
`;

export const WalletTitle = styled.div`
  font-weight: 600;
  font-size: 14px;
  color: #ffffffbf;
`;

export const WalletContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const SeedAmount = styled.div`
  font-family: esamanru;
  font-weight: 500;
  font-size: 24px;
  line-height: 100%;
  letter-spacing: 0px;
  color: #fff;
`;

export const PointSection = styled.div`
  align-items: center;
  display: flex;
  gap: 10px;
`;

export const PointText = styled.div`
  font-weight: 400;
  font-size: 13px;
  color: #ffffff99;

  span {
    font-weight: 400;
    font-size: 13px;
    color: #ffffffcc;
  }
`;

export const ArrowIcon = styled.img`
  width: 14px;
  height: 14px;
`;

export const MainWalletTierWrapper = styled.div`
  width: 100%;
  background: #ffffff1a;
  height: 75px;
  border-radius: 9px;
  display: flex;
  margin-top: 15px;

  > .tier-wrapper {
    flex: 1.2;
    display: flex;
    gap: 8px;
    padding: 17px 10px;

    > .img-wrapper {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 1px;

      > .tier {
        width: 35px;
      }

      > .rank {
        width: 35px;
      }

      > .blur {
        width: 24px;
        height: 5px;
        border-radius: 50%;
        top: 232px;
        left: 198px;
        background: #00000026;
        filter: blur(3.5px);
      }
    }

    > .item {
      display: flex;
      flex-direction: column;

      > .name {
        font-weight: 500;
        font-size: 11px;
        color: #ffffffcc;
      }

      > .value-wrapper {
        display: flex;
        gap: 5px;
        align-items: flex-end;

        > .value {
          font-weight: 700;
          font-size: 18px;
          color: #ffffff;

          > span {
            font-weight: 500;
            font-size: 11px;
            color: #ffffffcc;
          }
        }

        > .item {
          width: auto;
          height: 17px;
          border-radius: 5.48px;
          padding-top: 4px;
          padding-right: 3px;
          padding-bottom: 4px;
          padding-left: 3px;
          gap: 2px;
          background: #ffffff1a;
          display: flex;

          font-weight: 700;
          font-size: 9px;
          line-height: 100%;
          color: #fff;
          align-items: center;

          > img {
            width: 7px;
          }
        }
      }
    }
  }
`;

// 티어/랭킹 관련 스타일드 컴포넌트들
export const TierWrapper = styled.div<{ flex?: number }>`
  flex: ${(props) => props.flex || 1.2};
  display: flex;
  gap: 8px;
  padding: 16px 10px 16px;
  cursor: pointer;
`;

export const ImageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1px;
`;

export const TierImage = styled.img`
  width: 35px;
`;

export const BlurEffect = styled.div`
  width: 24px;
  height: 5px;
  border-radius: 50%;
  background: #00000026;
  filter: blur(3.5px);
`;

export const ItemContent = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ItemName = styled.div`
  font-weight: 500;
  font-size: 11px;
  color: #ffffffcc;
`;

export const ValueWrapper = styled.div`
  display: flex;
  gap: 5px;
  align-items: flex-end;
`;

export const ValueText = styled.div`
  font-weight: 700;
  font-size: 18px;
  color: #ffffff;

  span {
    font-weight: 500;
    font-size: 11px;
    color: #ffffffcc;
  }
`;

export const DiffIndicator = styled.div`
  width: auto;
  height: 17px;
  border-radius: 5.48px;
  padding: 4px 3px;
  gap: 2px;
  background: #ffffff1a;
  display: flex;
  align-items: center;

  font-weight: 700;
  font-size: 9px;
  line-height: 100%;
  color: #fff;

  img {
    width: 7px;
  }
`;

export const TierContainer = styled.div`
  width: 100%;
  background: #ffffff1a;
  height: 66px;
  border-radius: 9px;
  display: flex;
  margin-top: 15px;
  cursor: pointer;
`;
